const demoWords = {
  "en-us": {
    dog: {
      PHON: "dˈɔg",
      GRAPHEMIC_BREAKDOWN: ["d", "o", "g", ""],
      IMG_URL: "https://amira-assets.s3.amazonaws.com/images/dog.jpg",
    },
    cat: {
      PHON: "kˈæt",
      GRAPHEMIC_BREAKDOWN: ["c", "a", "t", ""],
      IMG_URL: "https://amira-assets.s3.amazonaws.com/images/cat.jpg",
    },
  },
  "es-mx": {
    dog: {
      PHON: "p'e/ro",
      GRAPHEMIC_BREAKDOWN: ["p", "e", "rr", "o", ""],
      IMG_URL: "https://amira-assets.s3.amazonaws.com/images/dog.jpg",
    },
    cat: {
      PHON: "g'a/to",
      GRAPHEMIC_BREAKDOWN: ["g", "a", "t", "o", ""],
      IMG_URL: "https://amira-assets.s3.amazonaws.com/images/cat.jpg",
    },
  }
};


export function getDemoWords(locale = 'en-us'){
  return demoWords[locale];
}
